export default "__VITE_PUBLIC_ASSET__e7c50869__"